import React from 'react';
import createMentionPlugin from '@workpatterns/draft-js-mention-plugin';

import Emoji from 'Shared/components/DraftEditor/components/EmojiComponent/EmojiComponent';

const EMOJI_TRIGGER = ':';

export function emojiMentionPluginCreator() {
  return createMentionPlugin({
    mentionComponent: props => <Emoji {...props} />,
    mentionPrefix: '',
    mentionTrigger: EMOJI_TRIGGER,
    positionSuggestions: settings => ({
      left: `${settings.decoratorRect.left}px`,
      top: window.innerWidth > 480 ? `${settings.decoratorRect.top - 10}px` : '0px',
      display: 'block',
      position: window.innerWidth > 480 ? 'fixed' : 'absolute',
      transform: 'scale(1) translateY(-100%)',
      transformOrigin: '1em 0% 0px',
      transition: 'all 0.25s cubic-bezier(0.3, 1.2, 0.2, 1)',
      zIndex: '1050',
      maxHeight: '300px',
      overflowY: 'auto',
      fontWeight: 'normal',
    }),
    supportWhitespace: true,
  });
}
